export const strokeWidth = {
  default: '0.5px',
  strong: '1px',
  strongest: '1.5px',
} as const
